// extracted by mini-css-extract-plugin
export default {"root":"_63eeZjOE","main":"Yfk4zgbB","title":"_5fMXNN8D","description":"e0BqMeTK"};